import { axiosGet, axiosPost } from '../../axios/axios.js'

export function setColumnWidths (widths, tableName, store) {
  if (store.getters.getChangeWidthTimerID(tableName)) {
    clearTimeout(store.getters.getChangeWidthTimerID(tableName))
  }
  store.dispatch('setColumnWidths', { [tableName]: widths })
  store.dispatch('setChangeWidthTimerID', {
    [tableName]: setTimeout(() => {
      const widths = store.getters.getColumnWidths
      const tableColumnsWidths = widths[tableName]
      if (tableColumnsWidths) {
        sendTableColumnsWidths(tableName, tableColumnsWidths)
      }
    }, 5000)
  })
}

export function saveColumnWidths (widths, tableName, store) {
  store.dispatch('setColumnWidths', { [tableName]: widths })
}

export function setDefaultWidths (defaultColumns, tableName, store) {
  defaultColumns.forEach(column => {
    column.style = column.defaultWidth ? 'min-width: ' + column.defaultWidth + 'px' : ''
  })
  store.dispatch('setColumnWidths', { [tableName]: {} })

  const widths = store.getters.getColumnWidths
  return sendTableColumnsWidths(tableName, widths[tableName])
}

function sendTableColumnsWidths (tableName, tableColumnsWidths) {
  return sendTableSettings(tableName, {
    widths: tableColumnsWidths
  })
}

export function sendTableSettings (tableName, props, folder = 'delta-table-config') {
  const bodyFormData = new FormData()
  bodyFormData.set('folder', folder)
  bodyFormData.set('prefix', folder + '.' + tableName)
  bodyFormData.set('props', JSON.stringify(props))

  return axiosPost({
    url: '/service/settings/set',
    data: bodyFormData,
    config: {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    },
    onFailure: 'Ошибка сохранения настроек таблицы',
    throws: true
  }).finally(() => {
    console.log('request sent')
  })
}

export function loadTableSettings (tableName, folder = 'delta-table-config') {
  return axiosGet({
    url: '/service/settings/map' + '?prefix=' + folder + '.' + tableName,
    onSuccess: response => response.data,
    onFailure: 'Ошибка получения настроек таблицы'
  })
}
